import React, { useContext, useState, useEffect, createContext } from 'react';

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

function _iterableToArrayLimit(arr, i) {
  var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
  if (_i == null) return;
  var _arr = [];
  var _n = true;
  var _d = false;
  var _s, _e;
  try {
    for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);
      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }
  return _arr;
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }
  return arr2;
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}

function _typeof(obj) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
    return typeof obj;
  } : function (obj) {
    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
  }, _typeof(obj);
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }
  return target;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = _objectWithoutPropertiesLoose(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }
  return target;
}

var ButtonImg = "data:image/svg+xml,%3Csvg%20width%3D%22212%22%20height%3D%2240%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%20%20%3Cg%20fill%3D%22none%22%20fill-rule%3D%22evenodd%22%3E%20%20%20%20%3Crect%20fill%3D%22%23167FFC%22%20width%3D%22212%22%20height%3D%2240%22%20rx%3D%223%22%2F%3E%20%20%20%20%3Cpath%20d%3D%22M58.39%2026v-3.03h2.37c.9%200%201.7-.15%202.38-.45a3.43%203.43%200%200%200%202.09-3.28%203.6%203.6%200%200%200-.54-2%203.46%203.46%200%200%200-1.55-1.29%205.81%205.81%200%200%200-2.38-.45h-4.32V26h1.95Zm2.28-4.68h-2.28v-4.17h2.28c.85%200%201.5.18%201.93.54.44.36.66.88.66%201.54%200%20.68-.22%201.19-.66%201.55-.44.36-1.08.54-1.93.54Zm8.9%204.79c.6%200%201.1-.1%201.53-.28.43-.19.75-.45.98-.8V26h1.77v-4.7c0-1.14-.31-1.99-.93-2.55-.63-.57-1.53-.85-2.71-.85-.66%200-1.29.09-1.88.26-.59.16-1.1.41-1.51.73l.73%201.36c.3-.25.67-.44%201.1-.58a4.3%204.3%200%200%201%201.33-.21c.66%200%201.16.15%201.5.45.33.3.5.73.5%201.29v.12H69.9c-1.15%200-2%20.22-2.53.65-.53.44-.8%201.02-.8%201.73%200%20.46.12.88.36%201.24.25.37.6.65%201.05.86.45.2.97.3%201.57.3Zm.38-1.37c-.48%200-.85-.1-1.12-.3a.96.96%200%200%201-.4-.81c0-.71.53-1.06%201.61-1.06h1.94v.93c-.15.4-.41.7-.78.92-.36.21-.78.32-1.25.32ZM78.13%2026v-3.89c0-.8.2-1.4.61-1.83.41-.43.98-.64%201.71-.64.13%200%20.28.02.44.04V17.9c-1.36%200-2.31.42-2.85%201.26v-1.17h-1.79V26h1.88Zm6.84.1c.6%200%201.11-.09%201.53-.27.43-.19.76-.45.99-.8V26h1.77v-4.7c0-1.14-.32-1.99-.94-2.55-.63-.57-1.53-.85-2.7-.85-.67%200-1.3.09-1.88.26-.6.16-1.1.41-1.52.73l.74%201.36c.3-.25.67-.44%201.1-.58a4.3%204.3%200%200%201%201.33-.21c.66%200%201.16.15%201.49.45.34.3.5.73.5%201.29v.12h-2.07c-1.15%200-1.99.22-2.53.65-.53.44-.8%201.02-.8%201.73%200%20.46.13.88.37%201.24.25.37.6.65%201.04.86.45.2.98.3%201.58.3Zm.39-1.36c-.48%200-.86-.1-1.13-.3a.96.96%200%200%201-.4-.81c0-.71.54-1.06%201.62-1.06h1.93v.93c-.15.4-.4.7-.77.92-.36.21-.78.32-1.25.32ZM93.53%2026V14.87h-1.87V26h1.87Zm4.34%200V14.87h-1.88V26h1.88Zm6.22.1c.7%200%201.31-.1%201.86-.33.55-.21%201-.54%201.37-.97l-1-1.16c-.58.59-1.3.88-2.18.88-.7%200-1.27-.18-1.73-.52a2.18%202.18%200%200%201-.87-1.4h6.29l.03-.56c0-.82-.17-1.54-.52-2.17a3.67%203.67%200%200%200-1.44-1.45%204.2%204.2%200%200%200-2.1-.52c-.78%200-1.5.18-2.12.53-.63.34-1.13.83-1.48%201.46a4.2%204.2%200%200%200-.53%202.1c0%20.8.18%201.5.55%202.13.36.62.88%201.11%201.55%201.46.67.35%201.44.53%202.32.53Zm1.98-4.75h-4.54c.09-.59.34-1.06.75-1.42.42-.35.93-.53%201.53-.53s1.12.18%201.53.54c.4.36.65.83.73%201.41Zm5.46%204.65V14.87h-1.87V26h1.87Zm8.73%200v-3.03h2.37c.91%200%201.7-.15%202.38-.45a3.38%203.38%200%200%200%202.09-3.28%203.6%203.6%200%200%200-.54-2%203.46%203.46%200%200%200-1.55-1.29%205.81%205.81%200%200%200-2.38-.45h-4.32V26h1.95Zm2.28-4.68h-2.28v-4.17h2.28c.85%200%201.5.18%201.94.54.44.36.66.88.66%201.54%200%20.68-.22%201.19-.66%201.55-.44.36-1.09.54-1.94.54Zm8.9%204.79c.6%200%201.11-.1%201.53-.28.43-.19.76-.45.99-.8V26h1.77v-4.7c0-1.14-.31-1.99-.94-2.55-.63-.57-1.53-.85-2.7-.85-.67%200-1.3.09-1.88.26-.6.16-1.1.41-1.52.73l.74%201.36c.3-.25.66-.44%201.1-.58a4.3%204.3%200%200%201%201.33-.21c.66%200%201.15.15%201.49.45.34.3.5.73.5%201.29v.12h-2.07c-1.15%200-1.99.22-2.53.65-.53.44-.8%201.02-.8%201.73%200%20.46.13.88.37%201.24.25.37.6.65%201.04.86.45.2.98.3%201.58.3Zm.39-1.37c-.48%200-.86-.1-1.13-.3a.96.96%200%200%201-.4-.81c0-.71.54-1.06%201.62-1.06h1.93v.93c-.15.4-.4.7-.77.92-.37.21-.78.32-1.25.32Zm8.77%201.37c1.12%200%202-.23%202.66-.68.65-.45.97-1.05.97-1.8%200-.57-.14-1.01-.44-1.32a2.5%202.5%200%200%200-1.06-.66c-.4-.13-.93-.24-1.57-.34a7.27%207.27%200%200%201-1.42-.36c-.3-.12-.46-.34-.46-.63%200-.27.15-.5.43-.66.28-.16.7-.25%201.25-.25.85%200%201.62.2%202.3.6l.72-1.42c-.35-.21-.8-.38-1.35-.5a7.42%207.42%200%200%200-1.65-.19c-1.08%200-1.94.23-2.57.68a2.13%202.13%200%200%200-.96%201.83c0%20.57.16%201.03.46%201.35.3.33.66.55%201.08.68.41.13.95.25%201.61.35.63.1%201.09.2%201.38.32.28.1.42.3.42.58%200%20.59-.56.88-1.68.88a5.4%205.4%200%200%201-2.79-.79l-.72%201.42c.37.27.87.48%201.49.65.62.17%201.25.25%201.9.25Zm7.73%200c1.12%200%202-.23%202.65-.68a2.1%202.1%200%200%200%20.98-1.8c0-.57-.15-1.01-.45-1.32a2.41%202.41%200%200%200-1.05-.66%2011.1%2011.1%200%200%200-1.58-.34%207.27%207.27%200%200%201-1.41-.36c-.31-.12-.46-.34-.46-.63%200-.27.14-.5.43-.66.28-.16.7-.25%201.25-.25.85%200%201.61.2%202.3.6l.71-1.42c-.35-.21-.8-.38-1.35-.5a7.42%207.42%200%200%200-1.65-.19c-1.08%200-1.94.23-2.57.68a2.13%202.13%200%200%200-.95%201.83c0%20.57.15%201.03.45%201.35.31.33.67.55%201.09.68.41.13.95.25%201.6.35.64.1%201.1.2%201.38.32.29.1.43.3.43.58%200%20.59-.56.88-1.68.88a5.4%205.4%200%200%201-2.8-.79l-.71%201.42c.37.27.86.48%201.48.65.62.17%201.26.25%201.9.25Zm7.12%202.8v-3.89a3.23%203.23%200%200%200%202.57%201.09c.78%200%201.47-.18%202.09-.52.61-.34%201.1-.82%201.45-1.44.35-.63.52-1.34.52-2.15%200-.82-.17-1.53-.52-2.15a3.68%203.68%200%200%200-1.45-1.44%204.25%204.25%200%200%200-3.6-.23%202.9%202.9%200%200%200-1.15.86v-1.05h-1.78v10.92h1.87Zm2.36-4.41a2.22%202.22%200%200%201-2.07-1.18%202.68%202.68%200%200%201-.32-1.32c0-.5.1-.95.32-1.32.2-.38.5-.68.85-.88.36-.2.77-.31%201.22-.31.69%200%201.25.23%201.7.69.45.46.67%201.07.67%201.82a2.5%202.5%200%200%201-.67%201.81c-.44.46-1.01.69-1.7.69Zm9.66%201.6c.82%200%201.55-.17%202.2-.52a3.83%203.83%200%200%200%201.53-1.46c.36-.63.54-1.34.54-2.13%200-.79-.18-1.49-.55-2.11a3.84%203.84%200%200%200-1.52-1.45%204.58%204.58%200%200%200-2.2-.53c-.81%200-1.54.18-2.2.53-.64.34-1.15.83-1.52%201.45a4.09%204.09%200%200%200-.54%202.12%203.9%203.9%200%200%200%202.07%203.58c.65.35%201.38.53%202.19.53Zm0-1.6c-.7%200-1.26-.23-1.7-.69a2.5%202.5%200%200%201-.67-1.81c0-.75.22-1.36.66-1.82a2.27%202.27%200%200%201%201.7-.69c.7%200%201.27.23%201.72.69.45.46.67%201.07.67%201.82s-.22%201.35-.67%201.81a2.3%202.3%200%200%201-1.71.69Zm7.95%201.5v-3.89c0-.8.2-1.4.61-1.83.41-.43.98-.64%201.71-.64.13%200%20.28.02.44.04V17.9c-1.36%200-2.31.42-2.85%201.26v-1.17h-1.79V26h1.88Zm7.44.1c.35%200%20.68-.04%201-.13.31-.09.58-.22.8-.4l-.53-1.34c-.28.22-.63.33-1.05.33-.36%200-.63-.1-.82-.3-.2-.21-.29-.51-.29-.9v-3.81h2.15v-1.5h-2.15v-1.83h-1.87v1.83h-1.32v1.5h1.32v3.86c0%20.88.24%201.54.72%202%20.48.46%201.16.7%202.04.7Z%22%20fill%3D%22%23FFF%22%20fill-rule%3D%22nonzero%22%2F%3E%20%20%20%20%3Cg%20stroke%3D%22%23FFF%22%3E%20%20%20%20%20%20%3Cpath%20stroke-width%3D%22.9%22%20stroke-linecap%3D%22square%22%20d%3D%22M12.5%2010v20m24-20v20%22%2F%3E%20%20%20%20%20%20%3Cg%20transform%3D%22translate%2820%2013%29%22%3E%20%20%20%20%20%20%20%20%3Cpath%20d%3D%22M.29.12h1v14.33h-1z%22%2F%3E%20%20%20%20%20%20%20%20%3Cellipse%20stroke-width%3D%221.7%22%20cx%3D%225.45%22%20cy%3D%224.97%22%20rx%3D%224.54%22%20ry%3D%224.75%22%2F%3E%20%20%20%20%20%20%3C%2Fg%3E%20%20%20%20%3C%2Fg%3E%20%20%3C%2Fg%3E%3C%2Fsvg%3E";

var _excluded = ["parallel", "children"];
var ParallelContext = /*#__PURE__*/createContext({
  parallel: null
});
var ParallelProvider = function ParallelProvider(_ref) {
  var parallel = _ref.parallel,
    children = _ref.children,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement(ParallelContext.Provider, Object.assign({
    value: {
      parallel: parallel
    }
  }, props), children);
};
var isPromise = function isPromise(thing) {
  return thing !== null && _typeof(thing) === 'object' && typeof thing.then === 'function';
};
var wrapApiCall = function wrapApiCall(parallel, endpoint) {
  return function () {
    return new Promise(function (resolve, reject) {
      parallel.api(endpoint, resolve, reject);
    });
  };
};
var useParallel = function useParallel() {
  var _parallel$_config;
  var _useContext = useContext(ParallelContext),
    promise = _useContext.parallel;
  var _useState = useState(null),
    _useState2 = _slicedToArray(_useState, 2),
    parallel = _useState2[0],
    setParallel = _useState2[1];
  var _useState3 = useState(null),
    _useState4 = _slicedToArray(_useState3, 2),
    loginStatus = _useState4[0],
    setLoginStatus = _useState4[1];
  var _useState5 = useState(null),
    _useState6 = _slicedToArray(_useState5, 2),
    error = _useState6[0],
    setError = _useState6[1];

  // on first mount, get and then set the parallel lib
  useEffect(function () {
    if (isPromise(promise)) promise.then(setParallel);
  }, []);
  var handleLoginStatus = function handleLoginStatus(result) {
    var _result$error;
    // if there's an "error" key than an error occured
    setError((_result$error = result.error) !== null && _result$error !== void 0 ? _result$error : null);
    setLoginStatus(result);
  };
  useEffect(function () {
    if (!parallel || !isPromise(promise)) return;

    // fire a request to check status if we don't yet know what it is
    if (!loginStatus) parallel.getLoginStatus(handleLoginStatus);

    // subscribe to any changes in login status to ensure that our loginStatus state
    // always contains the current login status
    parallel.subscribe('auth.statusChange', handleLoginStatus);
    return function () {
      parallel.unsubscribe('auth.statusChange', handleLoginStatus);
    };
  }, [parallel]);
  if (!isPromise(promise)) {
    console.warn('You must call loadParallel and place the result in a <ParallelProvider parallel={result}> wrapper');
    return {};
  }

  // if we haven't loaded, return empty object
  if (!parallel) return {};

  // React recreates elements on render/re-render, causing any children iframe elements
  // to reload their src attribute which causes a reload of the Parallel experience within
  // the iframe - which is a bad experience for users
  if ((parallel === null || parallel === void 0 ? void 0 : (_parallel$_config = parallel._config) === null || _parallel$_config === void 0 ? void 0 : _parallel$_config.flow_type) === 'embed') {
    console.error('flow_type must be "redirect" or "overlay" when using React');
  }
  return {
    parallel: parallel,
    error: error,
    loginStatus: loginStatus,
    getProfile: wrapApiCall(parallel, '/me'),
    getBlockchain: wrapApiCall(parallel, '/blockchain'),
    getAccreditations: wrapApiCall(parallel, '/accreditations'),
    getIdentity: wrapApiCall(parallel, '/identity'),
    login: parallel.login,
    logout: parallel.logout
  };
};
var PassportButton = function PassportButton(props) {
  var _useParallel = useParallel(),
    parallel = _useParallel.parallel;
  if (!parallel) return null;
  var handleClick = function handleClick(e) {
    e.preventDefault();
    parallel.login();
  };
  return /*#__PURE__*/React.createElement("a", {
    role: "button",
    rel: "nofollow",
    onClick: handleClick,
    style: {
      cursor: 'pointer'
    }
  }, /*#__PURE__*/React.createElement("img", Object.assign({
    src: ButtonImg,
    alt: "Parallel Markets login button"
  }, props)));
};

export { ParallelProvider, PassportButton, useParallel };
